module.exports = __webpack_public_path__ + "805dc62daa8400e2ed5c8dce25d7a6b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/key-white.png
// module id = 43
// module chunks = 0